import TransactionStatusRoutes from "@/packages/c2bModules/SasaPayCheckTransactionStatus/TransactionStatusRoutes";
import TransactionStatusStore from "@/packages/c2bModules/SasaPayCheckTransactionStatus/TransactionStatusStore";
import TransactionStatusLinks from "@/packages/c2bModules/SasaPayCheckTransactionStatus/TransactionStatusLinks";
export default {
    install(Vue, options) {
        if (options.router) {
            options.router.addRoute(...TransactionStatusRoutes)
        }
        if (options.store) {
            options.store.registerModule('TransactionStatus', TransactionStatusStore)
            options.store.commit("Dashboard/SET_LINKS",TransactionStatusLinks)
        }
    }
}
